const state = {
    selectedItems: [],
    unselectedItems: [],
    backendArray: [],
    fixItems: []
};

const mutations = {
    SET_SELECTED_ARRAY: (state, payload) => {
        // if (payload.status) {

        state.unselectedItems = [];
        state.selectedItems = [];
        // if(status){
        state.fixItems.map((x, index) => {
            let i = payload.selected.indexOf(x.vehicleTruckId);
            // console.log(">>>", payload.selected)
            if (i >= 0) {
                state.selectedItems.push(x);
            } else if (state.backendArray.filter((y) => y.vehicleTruckId == x.vehicleTruckId).length > 0) {
                state.unselectedItems.push(x)
            } else if (x.isTruckMasterActive == '1') {
                state.unselectedItems.push(x)
            }
        });
    },
    UNSET_SELECTED_ARRAY: (state, payload) => {
        state.selectedItems = state.selectedItems.filter((x) => x.vehicleTruckId != payload.vehicleTruckId) // .indexOf(), 1);
        state.unselectedItems.push(payload)
    },
    SET_FIX_ARRAY: (state, payload) => {
        // console.log(" >>> payloadhere>>", payload)
        if (payload.length > 0) {
            state.fixItems = payload;
            let arr = payload.filter((x) => x.isTruckMasterActive == '1')
            console.log("arr", arr.length)
            state.unselectedItems = arr;
        }
    },
    SET_ID_BACKEND_ARRAY: (state, payload) => {
        console.log(" >>> BACKEND>>", payload)

        if (payload.length > 0) {
            state.backendArray = payload;
        }
    }
};

const actions = {
    setSelectedArray({
        commit
    }, payload) {
        commit("SET_SELECTED_ARRAY", payload);
    },
    setSelectedBackendArray({
        commit
    }, payload) {
        commit("SET_ID_BACKEND_ARRAY", payload);
    },
    setFixArray({
        commit
    }, payload) {
        commit("SET_FIX_ARRAY", payload);
    },
    setUnselectedArray({
        commit
    }, payload) {
        commit("UNSET_SELECTED_ARRAY", payload);
    }
};

const getters = {
    getSelectedArray: state => state.selectedItems,
    getUnselectedArray: state => state.unselectedItems,
    getFixArray: state => state.fixItems
};

export default {
    state,
    mutations,
    actions,
    getters
};


// WEBPACK FOOTER //
// ./src/store/module/vehicleSelectedData.js